module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }